<template>
    <module-box
        v-if="nbrInfo"
        class="md-nbr-info standard info-container"
        :fullColumn="fullColumn"
        :topSpacing="topSpacing"
        :btmSpacing="btmSpacing"
        :mobileTopSpacing="mobileTopSpacing"
        :mobileBtmSpacing="mobileBtmSpacing"
    >
        <div class="wrap">
            <div class="left-box">
                <p v-if="nbrInfo.type === 'neighborhood'" class="city-content">
                    <span>{{ nbrInfo.state }}</span>
                    <i class="iconfont icon-next"></i>
                    <span v-if="nbrInfo.city">
                        <a :href="cityLink" rel="noopener noreferrer">{{
                            nbrInfo.city
                        }}</a>
                    </span>
                </p>
                <p v-else class="city-content">
                    <span class="detail-city">{{ nbrInfo.state }}</span>
                </p>
                <h3 class="city">
                    <span>{{ nbrInfo.name }}</span>
                </h3>
            </div>
            <div class="right-box">
                <div class="item" v-for="item in dataList" :key="item.title">
                    <AttomTitle class="title" :item="item" />
                    <span
                        class="content"
                        v-html="item.label"
                    ></span>
                </div>
            </div>
        </div>
        <view-more
            class="city-dec"
            :line="2"
            :mobileLine="5"
            :noFold="noviewmore"
            :content="desc"
        ></view-more>
    </module-box>
</template>

<script>
import common from '../index';
import { normal } from '../../defaultSpacing';
export default {
    mixins: [common],
    data: function() {
        return {
            ...normal
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-nbr-info.standard {
    overflow: unset;
    .wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--color-border);
        .left-box {
            margin: 0 33px 20px 0;
            padding-left: 20px;
            border-left: 8px solid;
            @include color-theme('border-color');
            text-transform: uppercase;
            flex: none;
            .city-content {
                color: var(--color-disable);
                font-size: 18px;
                line-height: 100%;
                text-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                .icon-next {
                    font-size: 12px;
                    display: inline-block;
                    transform: scale(0.7);
                    position: relative;
                    top: -3px;
                }
            }
            .city {
                font-size: 30px;
                font-family: var(--font-bold);
                line-height: 33px;
                margin-top: 10px;
                color: var(--color-text);
            }
        }
        .right-box {
            margin: 0 0 20px -40px;
            flex: none;
            display: flex;
            flex-wrap: wrap;
            .item {
                margin-left: 40px;
                color: var(--color-disable);
                .title {
                    display: block;
                    font-size: 14px;
                    line-height: 1.2;
                    margin-top: 4px;
                }
                .content {
                    display: block;
                    font-size: 24px;
                    line-height: 30px;
                    font-family: var(--font-medium);
                    margin-top: 10px;
                    > span {
                        display: block;
                    }
                }
            }
        }
    }
    .city-dec {
        margin-top: 20px;
        line-height: 1.63;
        font-size: 16px;
        color: var(--color-disable);
        .more-btn {
            cursor: pointer;
            width: 50px;
            text-decoration: underline;
        }
    }
    @include media-600 {
        .info-container {
            margin-left: 0;
            margin-right: 0;
        }
        .wrap {
            border-bottom: none;
            .left-box {
                width: calc(100% - 20px);
                margin: 0 5px 30px 15px;
                padding-left: 10px;
                border-left: 4px solid;
                @include color-theme('border-color');
                .city-content {
                    font-size: 14px;
                    line-height: 18px;
                    .icon-next {
                        top: -1px;
                    }
                }
                .city {
                    font-size: 20px;
                    line-height: 22px;
                    margin-top: 0;
                }
            }
            .right-box {
                border-top: 1px solid var(--color-border);
                margin: 0;
                width: 100%;
                padding: 0 15px;
                justify-content: space-between;
                .item {
                    margin: 20px 0 0 0;
                    width: 49%;
                    .title {
                        margin-top: 0;
                    }
                    .content {
                        font-size: 18px;
                        line-height: 30px;
                        margin-top: 0;
                    }
                }
            }
        }
        .city-dec {
            line-height: 1.43;
            font-size: 14px;
            margin: 20px 15px 0 15px;
        }
    }
}
</style>
